export enum ErrorSources {
    SSDR_Web,
    SQL,
    ProcureShip,
    ShipServ,
    MailboxPdf,
    IntegrationService,
    Robot
}